module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_Settings_16"],"path":[{"$":{"d":"M16,9V7l-2.72-.54a5.47,5.47,0,0,0-.45-1.1l1.54-2.31L12.95,1.64,10.64,3.18a5.47,5.47,0,0,0-1.1-.45L9,0H7L6.46,2.72a5.47,5.47,0,0,0-1.1.45L3.05,1.64,1.64,3.05,3.18,5.36a5.47,5.47,0,0,0-.45,1.1L0,7V9l2.72.54a5.46,5.46,0,0,0,.45,1.1L1.64,12.95l1.41,1.41,2.31-1.54a5.47,5.47,0,0,0,1.1.45L7,16H9l.54-2.72a5.47,5.47,0,0,0,1.1-.45l2.31,1.54,1.41-1.41-1.54-2.31a5.46,5.46,0,0,0,.45-1.1ZM11,8A3,3,0,1,1,8,5,3,3,0,0,1,11,8Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_Settings_16.svg
// module id = BHBv
// module chunks = 1